/**
 * Stripped-down path utilities for browser use.
 * WebContainer paths are always forward-slash POSIX paths.
 */

export function dirname(p: string): string {
  const idx = p.lastIndexOf('/');
  if (idx <= 0) return '';
  return p.substring(0, idx);
}

export function basename(p: string): string {
  const idx = p.lastIndexOf('/');
  return idx === -1 ? p : p.substring(idx + 1);
}

export function extname(p: string): string {
  const name = basename(p);
  const dotIdx = name.lastIndexOf('.');
  if (dotIdx <= 0) return '';
  return name.substring(dotIdx);
}

export function join(...parts: string[]): string {
  return parts
    .filter(Boolean)
    .join('/')
    .replace(/\/+/g, '/');
}
